module.exports = __webpack_public_path__ + "img/kz.9ec95eff.png";